import { makeStyles } from "tss-react/mui";
import { Box } from "@mui/material";

export const ColorOptionLabel = ({ label, color }) => {
  const { classes } = useStyles({ color });
  return (
    <Box className={classes.colorContainer}>
      <Box className={classes.colorItem} />
      {label}
    </Box>
  );
};

const useStyles = makeStyles()((_, { color } = {}) => ({
  colorContainer: {
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  colorItem: {
    height: 15,
    width: 15,
    borderRadius: 2,
    display: "block",
    backgroundColor: color,
  },
}));
